import React from "react";
import { ChevronRight } from "lucide-react";
import heroIllustration from "../assets/hero_img_with_camera_hand.webp";
import { useNavigate } from "react-router-dom";

const HeroSection = () => {
  const navigate = useNavigate();
  return (
    <section className="relative bg-gradient-to-r from-purple-700 to-indigo-800 text-white py-20 px-4 md:px-8 overflow-hidden">
      {/* Background shapes - mimicking the image */}
      <div className="absolute inset-0 z-0">
        <svg
          className="absolute w-full h-full"
          viewBox="0 0 1440 600"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 0H1440V450C1200 600 700 600 0 450V0Z"
            fill="url(#paint0_linear)"
          />
          <defs>
            <linearGradient
              id="paint0_linear"
              x1="720"
              y1="0"
              x2="720"
              y2="600"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#6D28D9" />
              <stop offset="1" stopColor="#4338CA" />
            </linearGradient>
          </defs>
          <circle cx="1000" cy="50" r="150" fill="rgba(255,255,255,0.05)" />
          <circle cx="1200" cy="300" r="100" fill="rgba(255,255,255,0.03)" />
          <path
            d="M-50 400C50 450 300 400 400 500L450 600H-50V400Z"
            fill="rgba(255,255,255,0.07)"
          />
        </svg>
      </div>

      <div className="container mx-auto flex flex-col-reverse lg:flex-row items-center lg:justify-between text-center lg:text-left relative z-10">
        {/* Text Content */}
        <div className="lg:w-1/2 mb-10 lg:mb-0 lg:pr-12 animate-fade-in-left">
          <h2 className="text-5xl md:text-6xl font-extrabold mb-6 leading-tight text-white">
            Nền tảng học online
          </h2>
          <p className="text-xl md:text-2xl mb-8 max-w-3xl text-gray-200">
            Học online với các video bài giảng dễ hiểu, hệ thống bài tập phù hợp
            giúp học sinh nắm chắc kiến thức đã học.
          </p>
          <button
            onClick={() => navigate("/guide")}
            className="bg-yellow-400 hover:bg-yellow-500 text-purple-800 font-bold py-4 px-10 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 text-lg flex items-center justify-center mx-auto lg:mx-0"
          >
            Tìm hiểu thêm <ChevronRight size={24} className="ml-2" />
          </button>
        </div>

        {/* Illustration Image */}
        <div className="lg:w-1/2 flex justify-center items-center animate-fade-in-right mb-6 lg:mb-0">
          <img
            src={heroIllustration} // Sử dụng ảnh local đã import
            alt="Online learning illustration"
            className="w-full h-auto object-contain max-w-md lg:max-w-none rounded-xl border-2 border-yellow-300 shadow-2xl"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src =
                "https://placehold.co/600x400/8B5CF6/FFFFFF?text=Illustration";
            }}
          />
        </div>
      </div>
      <style>
        {`
        @keyframes fadeInLeft {
          from { opacity: 0; transform: translateX(-50px); }
          to { opacity: 1; transform: translateX(0); }
        }
        @keyframes fadeInRight {
          from { opacity: 0; transform: translateX(50px); }
          to { opacity: 1; transform: translateX(0); }
        }
        .animate-fade-in-left { animation: fadeInLeft 1s ease-out forwards; }
        .animate-fade-in-right { animation: fadeInRight 1s ease-out forwards 0.3s; }
        `}
      </style>
    </section>
  );
};

export default HeroSection;
